import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Client-side canonicalization. Lovable hosting does not support
 * server redirects (no _redirects/netlify.toml/vercel.json), so we
 * normalize non-canonical URLs on the client:
 *
 *   - Strip trailing slash (except "/")
 *   - Lowercase the pathname (paths are case-sensitive by default,
 *     but our routes are all lowercase — uppercase variants 404)
 *   - Collapse duplicate slashes
 *
 * Query string and hash are preserved. Uses `replace` so the
 * non-canonical URL never enters browser history.
 */
/**
 * Routes whose path carries a case-sensitive token or id. Lowercasing these
 * breaks the lookup (e.g. read-only dossier share links), so they are exempt.
 */
const CASE_SENSITIVE_PREFIXES = [
  "/d/",
  "/r/",
  "/s/",
  "/ref/",
  "/invite/",
  "/share/",
];

export default function CanonicalRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let next = pathname.replace(/\/{2,}/g, "/");
    if (next.length > 1 && next.endsWith("/")) next = next.slice(0, -1);
    const exempt = CASE_SENSITIVE_PREFIXES.some((p) =>
      next.toLowerCase().startsWith(p),
    );
    const canonical = exempt ? next : next.toLowerCase();
    if (canonical !== pathname) {
      navigate(`${canonical}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);


  return null;
}
